export enum ProductEnum {
  SPA = "Spa",
  GOLF = "Golf",
  VERSA = "Versa",
  SALES_AND_CATETING = "Sales and Catering",
  RESERVE_ACTIVITIES = "Reserve Activities",
  RESERVE_DINING = "Reserve Dining",
  RETAIL = "Retail",
  TEST = "TEST",
}

export const ProductData = [
  ProductEnum.SPA,
  ProductEnum.GOLF,
  ProductEnum.VERSA,
  ProductEnum.SALES_AND_CATETING,
  ProductEnum.RESERVE_ACTIVITIES,
  ProductEnum.RESERVE_DINING,
  ProductEnum.RETAIL,
];

export enum SearchParams {
  TENANT = "tenantId",
  PROPERTY = "propertyId",
  PRODUCT = "productId",
}

export const ProductMap = {
  [ProductEnum.SPA]: 1,
  [ProductEnum.GOLF]: 2,
  [ProductEnum.RETAIL]: 3,
  [ProductEnum.SALES_AND_CATETING]: 5,
  [ProductEnum.RESERVE_ACTIVITIES]: 12,
  [ProductEnum.RESERVE_DINING]: 13,
  [ProductEnum.VERSA]: 6,
  [ProductEnum.TEST]: 100,
};

export const getProductID = (productType: string): number | undefined => {
  return ProductMap[productType as ProductEnum];
};

export const getProductType = (productId: number): string | undefined => {
  const entry = Object.entries(ProductMap).find(
    ([_, value]) => value === productId,
  );
  return entry ? entry[0] : undefined;
};
